// extracted by mini-css-extract-plugin
export default {"eventList":"EventsList_eventList__5w5ux","eventsListContainer":"EventsList_eventsListContainer__oa2Z2","paginationBlock":"EventsList_paginationBlock__cPgoi"};